import { isAnswerEnrichmentAction, isStrategicEnrichmentAction } from '../../helper/chatArtifactActionKinds';
import { offerCostLabel } from './chatEnrichmentOfferModel';

export function sleep(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

export function actionConfirmationMessage(action) {
  const confirmation = action?.confirmation_message || action?.confirmation?.message || action?.confirmation;
  const lines = [];
  if (typeof confirmation === 'string' && confirmation.trim()) {
    lines.push(confirmation.trim());
  }
  // A paid run is never confirmed without its price: the backend label, else the
  // same per-company or quoted price the enrich control shows.
  const paid = isAnswerEnrichmentAction(action) || isStrategicEnrichmentAction(action);
  const price = action?.cost_label || (paid ? offerCostLabel(action) || 'Price shown at approval.' : null);
  if (price) {
    lines.push(price);
  }
  if (action?.scope_label) {
    lines.push(action.scope_label);
  }
  if (action?.scope_count !== undefined && action?.scope_count !== null) {
    lines.push(`${action.scope_count} ${action.scope_count === 1 ? 'company' : 'companies'}`);
  }
  if (action?.query) {
    lines.push(`Researching: ${action.query}`);
  }
  const staleCopy = action?.stale_confirmation_copy || action?.stale_confirmation_message;
  if (staleCopy) {
    lines.push(staleCopy);
  }
  if (action?.disabled_reason) {
    lines.push(action.disabled_reason);
  }
  if (lines.length > 0) return lines.join('\n');
  return action?.label ? `Run ${action.label}?` : 'Run this artifact action?';
}
